import React from "react";
import RecruiterImg from "../../Assets/img/Group (2).svg"; // adjust path

const CandidateBanner = () => {
  return (
    <div className="container-benner-candidate">
      <div className="container">
        <div className="row-12 align-items-center d-flex">
          {/* Left Box: Content */}
          <div className="col-md-8 text-center text-md-start">
            <h1 className="banner-title-candidate">
              Rise Above the Competition in Recruiter Searches
            </h1>
            <p className="banner-subtitle-candidate">
              Unlock more profile views and attract top recruiters actively hiring in your industry.
            </p>
          </div>

          {/* Right Box: Image */}
          <div className="col-md-4 text-center">
            <img
              src={RecruiterImg}
              alt="Recruiter Illustration"
              className="banner-img-candidate"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateBanner;
